module.exports = __webpack_public_path__ + "1792395595471/images/south-america.e828146.png";